
export default function BasicSpecs() {
  const specs = [
    { label: 'カード名', value: 'ジャックス Gold Time（ゴールドタイム）' },
    { label: '年会費', value: '初年度無料、次年度以降5,500円（税込）※年5回以上利用で翌年も無料' },
    { label: 'ポイント還元率', value: '1.0%〜2.0%（200円で2ポイント、外食・分割払いで4ポイント）' },
    { label: '国際ブランド', value: 'Visa' },
    { label: 'カード種別', value: 'ゴールドカード' },
    { label: '申込条件', value: '年齢20歳以上で安定した収入のある電話連絡可能な方（学生を除く）' },
    { label: 'ポイント名', value: 'Gold Timeポイント（自動でJデポに交換）' },
    { label: 'ポイント有効期限', value: '自動値引きのため失効なし' },
    { label: '電子マネー', value: 'Apple Pay / Google Pay / QUICPay' },
    { label: '海外旅行傷害保険', value: '最高3,000万円（利用付帯）' },
    { label: '国内旅行傷害保険', value: '最高3,000万円（利用付帯）' },
    { label: 'カード盗難保険', value: '届出日から60日前まで補償' },
    { label: 'ネットあんしんサービス', value: '届出日から90日前まで補償' },
    { label: 'ETCカード', value: '年会費無料' },
    { label: '家族カード', value: '1枚目無料、2枚目以降550円（税込）※条件付き無料' },
    { label: '空港ラウンジ', value: '国内主要空港＋ハワイ ホノルル空港 無料' },
    { label: '締め日・支払日', value: '月末締め・翌月27日払い' },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-8 text-center">
          ジャックス Gold Timeの基本スペック
        </h2>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <table className="w-full">
            <tbody>
              {specs.map((spec, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-[#F8F9FA]' : 'bg-white'}>
                  <td className="px-6 py-4 text-sm font-bold text-gray-700 border-b border-gray-200 w-1/3">
                    {spec.label}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 border-b border-gray-200">
                    {spec.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
